export default function () {
  const localeList = {
    uk: ['en_GB', 'as_AS'],
    fr: ['fr_FR'],
    de: ['de_DE'],
    ie: ['en_IE', 'sd_IE'],
    at: ['de_AT'],
    ch: ['de_CH'],
    es: ['es_ES'],
    it: ['it_IT'],
    '': ['sd_SD']
  }

  // Get Url Prefix.
  let prefix = `${window.location.pathname.replace(/^\/([^/]*).*$/, '$1')}`

  if (prefix.length !== 2) { // Condition for Superdrug UK which has no prefix
    prefix = ''
  }

  // Get Locale.
  let serviceId

  // Get Brand.
  let brand = 'zava'
  if (window.location.origin.match(/tosca|asda/g)) {
    brand = 'tosca'
  } else if (window.location.origin.match(/superdrug|sd/g)) {
    brand = 'sd'
  } else if (window.location.origin.match(/dred/g)) {
    brand = 'dred'
  }
  let locale = localeList[prefix][0]
  const urlPrefix = localeList[prefix] ? prefix : ''

  if (locale === 'en_IE' && brand === 'sd') {
    locale = 'sd_IE'
  } else if (locale === 'en_GB' && brand === 'tosca') {
    locale = 'as_AS'
  }

  const countryCode = (['', 'uk'].includes(prefix) ? 'gb' : urlPrefix).toUpperCase()

  // Get service id from Url
  // TODO get a better solution (probably regex)
  // TODO also we need to handle query parameters
  const urlParts = window.location.pathname.split('/assessment/')
  if (urlParts && urlParts.length === 2) {
    serviceId = urlParts[1].split('?/')[0]
  }

  // removing loader if url param present (for e2e tests)
  // TODO replace occurences of optimizely_disable=true from tests with e2e_enabled=true. Then remove optimizely_disable=true
  // from here
  const locationHref = window.location.href
  const e2eEnabled = locationHref.includes('optimizely_disable=true') || locationHref.includes('e2e_enabled=true')
  if (e2eEnabled && window.document.getElementById('loader')) {
    window.document.getElementById('loader').remove()
  }

  // create additional headers based on url that can be used with window.fetch
  const additionalHeaders = {
    country: countryCode,
    hostname: window.location.hostname,
    site: brand
  }

  return [urlPrefix, serviceId, brand, locale, additionalHeaders]
}
